import { adminClient } from "@/lib/api";

const eventsKey = (m) => `dv_events_${m}`;
const queueKey = (m) => `dv_queue_${m}`;

const read = (k) => {
  try {
    return JSON.parse(localStorage.getItem(k) || "[]");
  } catch {
    return [];
  }
};
const write = (k, v) => localStorage.setItem(k, JSON.stringify(v));

export const loadCachedEvents = (matchId) => read(eventsKey(matchId));
export const saveCachedEvents = (matchId, events) => write(eventsKey(matchId), events);
export const loadQueue = (matchId) => read(queueKey(matchId));

export function enqueue(matchId, event) {
  write(queueKey(matchId), [...read(queueKey(matchId)), event]);
}

export function clearMatchCache(matchId) {
  localStorage.removeItem(eventsKey(matchId));
  localStorage.removeItem(queueKey(matchId));
}

export const newId = () =>
  typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(16).slice(2)}`;

let flushing = {};

// Sends queued events in one batch. Returns true when queue is empty afterwards.
export async function flushQueue(matchId) {
  if (flushing[matchId]) return false;
  const queue = read(queueKey(matchId));
  if (queue.length === 0) return true;
  flushing[matchId] = true;
  try {
    await adminClient.post(`/datavolley/matches/${matchId}/events`, { events: queue });
    const remaining = read(queueKey(matchId)).filter((e) => !queue.some((q) => q.id === e.id));
    write(queueKey(matchId), remaining);
    return remaining.length === 0;
  } catch {
    return false;
  } finally {
    flushing[matchId] = false;
  }
}

export function mergeEvents(serverEvents, queued) {
  const seen = new Set(serverEvents.map((e) => e.id));
  return [...serverEvents, ...queued.filter((e) => !seen.has(e.id))];
}
